/* istanbul ignore file */
import React, { useRef, useEffect } from 'react';
import { AdaptiveCard } from 'adaptivecards';
import { mergeClasses } from '@fluentui/react-components';

export const ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS = {
  adaptiveCardsParserMaxVersion: undefined,
  cardEmphasisBackgroundColor: '#F9F9F9',
  cardPushButtonBackgroundColor: '#0063B1',
  cardPushButtonTextColor: 'White',
  richCardWrapTitle: false,
};

export interface IAdaptiveCardRendererProps {
  card: AdaptiveCard;
  className?: string;
  onMount?(root:HTMLDivElement): void;
}

export function AdaptiveCardRenderer({
  card, className, onMount,
}: IAdaptiveCardRendererProps) {
  const rootNode = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const renderedCard = card.render();

    if (renderedCard && rootNode.current) {
      const child = rootNode.current.firstChild;
      if (child) {
        rootNode.current.removeChild(child);
      }
      rootNode.current.appendChild(renderedCard);

      if (onMount) {
        onMount(rootNode.current);
      }
    }
  }, [card, onMount]);

  return (
    <div
      className={mergeClasses(className, 'adaptive-card')}
      ref={rootNode}
    />
  );
}

AdaptiveCardRenderer.defaultProps = {
  className: undefined,
  onMount: () => {},
};
